import React from 'react';

export default function Navbar() {
  return (
    <nav>
      <img className="nav--logo" src="../images/airbnb-logo.png" alt="Logo" />
    </nav>
  );
}
